import { render, staticRenderFns } from "./FormSpinbuttonVertical.vue?vue&type=template&id=6137e65d&"
import script from "./FormSpinbuttonVertical.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports